module.exports = __webpack_public_path__ + "img/banner.84f1bb41.png";